import { Flex, Skeleton } from '@mantine/core';
import Link from 'next/link';

import { Box, Button, Text } from '@/shared/ui';
import mainArticleStyles from './MainArticle/MainArticle.module.css';
import styles from './RubricCard.module.css';

const MainArticleSkeleton = () => {
  return (
    <div className={mainArticleStyles.root}>
      <Skeleton radius={4} w="100%" h={136} />

      <Flex mt={12} px={12} gap={6}>
        <Skeleton radius={4} w={60} h={7} />
        <Skeleton radius={4} w={60} h={7} />
      </Flex>

      <Flex px={12} mt={14} direction="column" gap={4}>
        <Skeleton radius={4} w="100%" h={16} />
        <Skeleton radius={4} w="75%" h={16} />
      </Flex>

      <Flex px={12} mt={12} mb={16} direction="column" gap={10}>
        <Skeleton radius={4} w="100%" h={7} />
        <Skeleton radius={4} w="75%" h={7} />
        <Skeleton radius={4} w="100%" h={7} />
      </Flex>
    </div>
  );
};

const ArticleSkeleton = () => {
  return (
    <Flex direction="column" gap={6} pl={16} pt={9}>
      <Skeleton radius={4} w="100%" h={16} />
      <Skeleton radius={4} w="75%" h={16} />
      <Skeleton radius={4} w="20%" h={7} />
    </Flex>
  );
};

interface TopicCardSkeletonProps {
  rubricName: string;
  slug: string;
}

export const RubricCardSkeleton = ({
  rubricName,
  slug,
}: TopicCardSkeletonProps) => {
  return (
    <Box
      className={styles.root}
      display="flex"
      flexDirection="column"
      padding={18}
      borderRadius={16}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        gap={12}
        paddingBottom={26}
        paddingTop={8}
        alignItems="center"
      >
        <Text
          fontSize={34}
          fontWeight={700}
          lineHeight={34}
          letterSpacing={-0.34}
          color="black"
          variant="secondary"
        >
          {rubricName}
        </Text>
        <Button asChild>
          <Link href={`/rubric/${slug}`}>Подробнее</Link>
        </Button>
      </Box>

      <div className={styles.content}>
        <div className={styles.main}>
          <MainArticleSkeleton />
          <MainArticleSkeleton />
        </div>
        <Box
          className={styles.articles}
          display="flex"
          flexDirection="column"
          paddingY={8}
          borderRadius={12}
        >
          <ArticleSkeleton />
          <ArticleSkeleton />
          <ArticleSkeleton />
          <ArticleSkeleton />
          <ArticleSkeleton />
          <ArticleSkeleton />
          <ArticleSkeleton />
          <ArticleSkeleton />
          <ArticleSkeleton />
        </Box>
      </div>
    </Box>
  );
};
